<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div v-if="!dashboard" class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Faturamento</h3>
        </div>
        <div class="col-6 text-center text-sm-right mb-0">
          <div>
            <span
              v-if="
                infoProfit.Partner.Name != null && infoProfit.Partner.Name != undefined && infoProfit.Partner.Name != ''
              "
              class="text-uppercase page-subtitle"
              >Parceiro: {{ infoProfit.Partner.Name }}</span
            >
            <br v-else />
          </div>
          <h3 class="page-title page-description">{{ infoProfit.Merchant.Name }}</h3>
        </div>
      </div>
      <!-- Page Header - Filters -->
      <div v-if="!loading" class="input-group d-flex justify-content my-auto">
        <date-field v-model="paymentDate" format="MMMM yyyy" minimumView="month" v-on:change="GetProfit()"></date-field>
        <div class="input-group-append">
          <b-button variant="primary" class="input-group-text" @click="GetProfit()">
            <i class="fas fa-search"></i>
          </b-button>
        </div>
      </div>

      <div v-if="HasServices" class="float-right">
        <div class="dropdown m-0">
          <button
            class="btn btn-outline-secondary dropdown-toggle-ellipsis-2"
            type="button"
            v-b-tooltip.hover.right
            title="Mais opções"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="fas fa-ellipsis-v"></i>
          </button>
          <div class="dropdown-menu" id="dropTableOptions" aria-labelledby="dropdownMenuButton">
            <a
              class="dropdown-item"
              href="#"
              :class="loadingReport ? 'disabled' : ''"
              v-on:click.stop="GetReport($event)"
            >
              <template v-if="loadingReport">
                <loader :small="true" :isLoading="loadingReport"></loader>
              </template>
              <template v-else>
                <i class="fas fa-check mr-2"></i>
                Gerar relatório
              </template>
            </a>
          </div>
        </div>
      </div>

      <d-row>
        <br />
      </d-row>
      <d-row v-if="!loading">
        <!-- Cards -->
        <d-col v-for="(card, index) in Cards" :key="index" md="6" :lg="card.lg" class="mb-4">
          <cards
            :id="`card-${index}`"
            :label="card.label"
            :value="card.value"
            :small-font-size-value="card.smallFontSizeValue"
          />
        </d-col>
      </d-row>
      <d-row v-if="loading || HasServices">
        <d-col class="mb-12 col-lg-12 lg-s" v-if="loading">
          <d-card class="card-small">
            <d-card-body class="p-0">
              <loader style="margin-top: 30px" :is-loading="loading" />
            </d-card-body>
          </d-card>
        </d-col>

        <d-col class="mb-5 col-lg-5 lg-s" v-if="!loading">
          <d-card class="card-small">
            <!-- Card Header -->
            <d-card-header class="border-bottom">
              <h6 class="m-0" style="font-weight: 600">DRE - Demonstração do Resultado do Exercício</h6>
            </d-card-header>
            <d-card-body class="p-0">
              <!-- Services List Group -->
              <d-list-group flush class="list-group-small">
                <d-list-group-item v-for="(serviceDetail, index) in this.DRE" :key="index" class="d-flex px-3">
                  <span class="text-semibold text-fiord-blue">{{ serviceDetail.Label }}</span>
                  <span :class="['ml-auto text-right text-semibold', serviceDetail.ColorClass]"
                    >{{ serviceDetail.Value }} {{ serviceDetail.Type }}</span
                  >
                </d-list-group-item>
              </d-list-group>
            </d-card-body>
            <d-card-footer class="border-top"></d-card-footer>
          </d-card>
        </d-col>
        <!-- Services -->
        <d-col class="mb-7 col-lg-7 lg-s" v-if="!loading">
          <hr />
          <d-card class="card-small go-stats">
            <!-- Card Header -->
            <d-card-header class="border-bottom">
              <h6 class="m-0" style="font-weight: 600">
                Composição da Receita Bruta<span style="float: right;margin-right: 10px;">Receita Bruta (R$)</span>
              </h6>
            </d-card-header>

            <d-card-body v-for="(service, index) in this.infoProfit.Services" :key="index" class="py-0">
              <!-- Services List Group -->
              <d-list-group flush class="list-group-small list-group-flush" style="margin-bottom: -16px;">
                <hr v-if="service.PaymentMethod.Code == 13" />
                <d-list-group-item class="d-flex row px-0" v-if="service.Quantity > 0">
                  <d-col lg="2" md="2" sm="2">
                    <center>
                      <img :src="GetDataImage(service.PaymentMethod.Code)" class="icon img-service" />
                    </center>
                  </d-col>

                  <d-col lg="6" md="6" sm="6">
                    <h6 class="go-stats__label mb-1">{{ service.PaymentMethod.Name }}</h6>
                    <div class="go-stats__meta">
                      <span class="mr-2">
                        <strong>{{ service.Quantity | number }}</strong> transações faturadas.

                        <strong
                          v-if="
                            service.PaymentMethod.Code == '1' ||
                              service.PaymentMethod.Code == '2' ||
                              service.PaymentMethod.Code == '3' ||
                              service.PaymentMethod.Code == '4' ||
                              service.PaymentMethod.Code == '5' ||
                              service.PaymentMethod.Code == '6' ||
                              service.PaymentMethod.Code == '13'
                          "
                          ><br />Valor movimentado de <strong class="text-success">{{ service.Amount | currency }}</strong
                          >.</strong
                        >
                      </span>
                    </div>
                  </d-col>
                  <d-col lg="4" md="4" sm="4" class="d-flex">
                    <div class="go-stats__value text-right ml-auto">
                      <h6 class="go-stats__label mb-1">{{ service.Tax | currency }}</h6>

                      <button
                        class="btn button-arrow"
                        type="button"
                        v-b-tooltip.hover.bottom
                        title="Clique aqui para detalhar esse serviço"
                        v-on:click="OpenService($event, index)"
                      >
                        <span class="go-stats__meta">Detalhar</span>
                        <i class="fas fa-angle-right"></i>
                      </button>
                    </div>
                  </d-col>
                  <hr v-if="service.PaymentMethod.Code == 13" width="100%" />
                </d-list-group-item>
              </d-list-group>
            </d-card-body>
            <d-card-footer class="border-top">
              <d-row>
                <!-- Footer -->
                <d-col class="text-right view-report">
                  <!-- <a
                    class="go-stats__meta"
                    href="#"
                    v-on:click="OpenModalChartMonth($event)"
                  >Ver faturamento anual</a>
                  <button
                    class="btn button-arrow ftr_chart"
                    type="button"
                    v-on:click="OpenModalChartMonth($event)"
                  >
                    <i class="fas fa-angle-down"></i>
                  </button> -->
                  <!-- <a
                    class="go-stats__meta"
                    href="#"
                    v-on:click="OpenModalChart($event)"
                  >Ver detalhes</a>
                  <button
                    class="btn button-arrow ftr_chart"
                    type="button"
                    v-on:click="OpenModalChart($event)"
                  >
                    <i class="fas fa-angle-down"></i>
                  </button> -->

                  <!-- <a class="go-stats__meta" href="#" v-on:click="OpenProfit($event)">Totais</a>
                  <button class="btn button-arrow" type="button" v-on:click="OpenProfit($event)">
                    <i class="fas fa-angle-down"></i>
                  </button> -->
                </d-col>
              </d-row>
            </d-card-footer>
          </d-card>
        </d-col>
      </d-row>
    </div>
    <b-modal id="mFormService" :title="modalTitle" centered :no-close-on-backdrop="true" :no-close-on-esc="false">
      <d-card class="card-small">
        <!-- Card Header -->
        <d-card-header class="border-bottom">
          <h6 class="m-0">Extrato</h6>
        </d-card-header>
        <d-card-body class="p-0">
          <!-- Services List Group -->
          <d-list-group flush class="list-group-small">
            <d-list-group-item v-for="(serviceDetail, index) in this.ServiceDetails" :key="index" class="d-flex px-3">
              <span class="text-semibold text-fiord-blue">{{ serviceDetail.Label }}</span>
              <span :class="['ml-auto text-right text-semibold', serviceDetail.ColorClass]"
                >{{ serviceDetail.Value }} {{ serviceDetail.Type }}</span
              >
            </d-list-group-item>
          </d-list-group>
        </d-card-body>
        <d-card-footer class="border-top"></d-card-footer>
      </d-card>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
      </template>
    </b-modal>
    <b-modal id="mFormChart" size="lg" title="Detalhes" centered>
      <chart-card title="Percentual de Lucro Líquido" :chartData="chartProfit"></chart-card>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import cards from "@/components/common/cards";
import chartCard from "@/components/common/chart-card";
import dateField from "@/components/common/date-field";
import colors from "../../utils/colors";
export default {
  name: "profit",
  props: {
    query: {},
    dashboard: {
      type: Boolean,
      default: false
    },
    idMerchantDashboard: {
      type: Number,
      default: 0
    }
  },
  components: {
    cards,
    chartCard,
    dateField
  },
  data: function() {
    return {
      loading: false,
      loadingReport: false,
      loadingChart: false,
      idMerchant: this.$route.params.idMerchant,
      paymentDate: this.$options.filters.date(new Date(), "YYYY-MM-DD"),
      modalTitle: "Detalhes",
      infoProfit: {
        CustTransfer: 0,
        Quantity: 0,
        Tax: 0,
        AcquirerTax: 0,
        MarginGross: 0,
        ISS: 0,
        Operation: 0,
        ProfitOperation: 0,
        ProfitOperationNet: 0,
        AmountChargeback: 0,
        TaxIR: 0,
        ProfitNet: 0,
        Amount: 0,
        AmountPartner: 0,
        Merchant: {
          Name: null
        },
        Partner: {
          Name: null
        },
        Services: []
      },
      infoDashboard: {
        MerchantsProfit: []
      },
      ServiceDetails: [],
      chartProfit: {
        labels: [],
        datasets: []
      },
      chartProfitMonth: {
        labels: [],
        datasets: []
      }
    };
  },
  computed: {
    PaymentDateYear() {
      return new Date(this.paymentDate).getUTCFullYear().toString();
    },
    HasServices() {
      if (this.infoProfit.Services == null || this.infoProfit.Services.length == 0) return false;
      for (var i = 0; i < this.infoProfit.Services.length; ++i) {
        var service = this.infoProfit.Services[i];
        if (service.Quantity > 0) return true;
      }
      return false;
    },
    Cards() {
      return [
        {
          label: "TPV",
          value: this.$options.filters.currency(this.infoProfit.Amount),
          smallFontSizeValue: true,
          lg: 3
        },
        {
          label: "Receita Bruta",
          value: this.$options.filters.currency(this.infoProfit.Tax),
          smallFontSizeValue: true,
          lg: 3
        },
        {
          label: "Lucro Bruto",
          value: this.$options.filters.currency(this.infoProfit.MarginGross),
          smallFontSizeValue: true,
          lg: 3
        },
        {
          label: "Resultado Líquido",
          value: this.$options.filters.currency(this.infoProfit.ProfitNet),
          smallFontSizeValue: true,
          lg: 3
        }
      ];
    }
  },
  mounted() {
    if (this.dashboard) {
      this.idMerchant = this.idMerchantDashboard;
      this.paymentDate = this.$options.filters.date(new Date(), "YYYY-MM-DD");
    } else {
      this.idMerchant = this.$route.params.idMerchant;
      this.paymentDate = this.$route.query.paymentDate;
    }

    this.GetProfit();
  },
  methods: {
    GetColorClass: function(type) {
      return type == "D" ? "text-red" : "text-green";
    },
    GetDataImage: function(code) {
      switch (code) {
        case "1":
          return require("@/assets/images/payment-methods/bankslip.svg");
        case "2":
          return require("@/assets/images/payment-methods/credit.svg");
        case "3":
          return require("@/assets/images/payment-methods/crypto.svg");
        case "4":
          return require("@/assets/images/payment-methods/debit.svg");
        case "6":
          return require("@/assets/images/payment-methods/logo_pix.svg");
        case "13":
          return require("@/assets/images/payment-methods/ted.svg");
        case "14":
          return require("@/assets/images/payment-methods/sms.svg");
        case "15":
          return require("@/assets/images/payment-methods/advance.svg");
        case "16":
          return require("@/assets/images/payment-methods/fraud.svg");
      }
      return require("@/assets/images/payment-methods/other.svg");
    },
    GetServiceIcon: function(code) {
      switch (code) {
        case "1":
          return '<i class="fas fa-tag"></i>';
        case "2":
          return '<i class="fas fa-credit-card"></i>';
        case "3":
          return '<i class="fab fa-btc"></i>';
        case "4":
          return '<i class="fas fa-credit-card"></i>';
        case "6":
          return '<i class="fas fa-money-check-alt"></i>';
      }
    },
    GetProfit: function() {
      this.ResetInfoProfit();
      this.loading = true;
      this.$store
        .dispatch("GetProfit", {
          idMerchant: this.idMerchant,
          paymentDate: this.paymentDate
        })
        .then(response => {
          this.infoProfit = response;

          this.FillDRE(this.infoProfit, false);

          this.chartProfit = {
            labels: [],
            datasets: []
          };

          let dataset = {
            data: [],
            icons: [],
            backgroundColor: []
          };
          let servicesPercentage = [];
          let profitNetTotal = 0;

          this.infoProfit.Services.forEach(element => {
            if (element.Quantity > 0) {
              profitNetTotal = profitNetTotal + element.ProfitNet;
            }
          });

          this.infoProfit.Services.forEach(element => {
            if (element.Quantity > 0) {
              servicesPercentage.push(this.CalculateServicePercentage(element.ProfitNet, profitNetTotal));
            }
          });
          let serviceColorPercentage = this.GetPercentageOnRange(servicesPercentage);

          this.infoProfit.Services.forEach(element => {
            if (element.Quantity > 0) {
              this.chartProfit.labels.push(element.PaymentMethod.Name);
              dataset.data.push(this.CalculateServicePercentage(element.ProfitNet, profitNetTotal));
              dataset.icons.push(this.GetServiceIcon(element.PaymentMethod.Code));
              dataset.backgroundColor.push(colors.primary.toRGBA(serviceColorPercentage.shift()));
            }
          });
          this.chartProfit.datasets.push(dataset);
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao carregar o faturamento", error);
        })
        .finally(() => (this.loading = false));
    },
    ResetInfoProfit: function() {
      this.infoProfit = {
        CustTransfer: 0,
        Quantity: 0,
        Tax: 0,
        AcquirerTax: 0,
        MarginGross: 0,
        ISS: 0,
        Operation: 0,
        ProfitOperation: 0,
        ProfitOperationNet: 0,
        AmountChargeback: 0,
        TaxIR: 0,
        ProfitNet: 0,
        Amount: 0,
        AmountPartner: 0,
        Merchant: {
          Name: null
        },
        Partner: {
          Name: null
        },
        Services: []
      };
    },
    CalculateServicePercentage: function(profitNet, profitNetTotal) {
      let percentage = parseFloat((profitNet * 100) / profitNetTotal);
      return percentage.toFixed(2);
    },
    GetPercentageOnRange: function(list, min = 0.35, max = 1.0) {
      let maxValue = Math.max(...list);

      return list.map(elm => {
        let percent = (elm * 100) / maxValue;
        return percent * ((max - min) / 100) + min;
      });
    },
    OpenService: function(e, i) {
      e.preventDefault();
      let service = this.infoProfit.Services[i];
      this.OpenModal("Detalhes de " + service.PaymentMethod.Name, service, true);
    },
    OpenProfit: function(e) {
      e.preventDefault();
      this.OpenModal("Totais", this.infoProfit, false);
    },
    OpenModalChart: function(e) {
      e.preventDefault();
      this.$bvModal.show("mFormChart");
    },
    OpenModalChartMonth: function(e) {
      e.preventDefault();
      this.GetProfitChart();
      this.$bvModal.show("mFormChartMonth");
    },

    FillDRE: function(service, isDetails) {
      if (isDetails || this.idMerchant > 0) {
        this.DRE = [
          {
            Label: "Receita Bruta",
            Value: this.$options.filters.currency(service.Tax),
            Type: "C",
            ColorClass: this.GetColorClass("C")
          },
          {
            Label: "(-) Deduções e abatimentos",
            Value: this.$options.filters.currency(service.ISS),
            Type: "D",
            ColorClass: this.GetColorClass("D")
          },
          {
            Label: "(=) Receita Líquida",
            Value: this.$options.filters.currency(service.ProfitOperation),
            Type: "C",
            ColorClass: this.GetColorClass("C")
          },
          {
            Label: "(-) Custos dos Serviços Prestados - CSP",
            Value: this.$options.filters.currency(service.AcquirerTax),
            Type: "D",
            ColorClass: this.GetColorClass("D")
          },
          {
            Label: "(=) Lucro Bruto",
            Value: this.$options.filters.currency(service.MarginGross),
            Type: "C",
            ColorClass: this.GetColorClass("C")
          },
          {
            Label: "(-) Despesas com Vendas",
            Value: this.$options.filters.currency(service.AmountPartner),
            Type: "D",
            ColorClass: this.GetColorClass("D")
          },
          {
            Label: "(-) Despesas Administrativas",
            Value: this.$options.filters.currency(service.Operation),
            Type: "D",
            ColorClass: this.GetColorClass("D")
          },
          {
            Label: "(-) Despesas Financeiras",
            Value: this.$options.filters.currency(service.CustTransfer),
            Type: "D",
            ColorClass: this.GetColorClass("D")
          },
          {
            Label: service.ProfitOperationNet > 0 ? "(=) Lucro" : "(=) Prejuízo" + " Operacional Líquido",
            Value: this.$options.filters.currency(
              service.ProfitOperationNet > 0 ? service.ProfitOperationNet : service.ProfitOperationNet * -1
            ),
            Type: service.ProfitOperationNet > 0 ? "C" : "D",
            ColorClass: service.ProfitOperationNet > 0 ? this.GetColorClass("C") : this.GetColorClass("D")
          },
          {
            Label: "(-) Provisões IRPJ E CSLL",
            Value: this.$options.filters.currency(service.TaxIR),
            Type: "D",
            ColorClass: this.GetColorClass("D")
          },
          {
            Label: "(=) Resultado Líquido",
            Value: this.$options.filters.currency(service.ProfitNet > 0 ? service.ProfitNet : service.ProfitNet * -1),
            Type: service.ProfitNet > 0 ? "C" : "D",
            ColorClass: service.ProfitNet > 0 ? this.GetColorClass("C") : this.GetColorClass("D")
          }
        ];
      } else {
        this.DRE = [
          {
            Label: "Receita Bruta",
            Value: this.$options.filters.currency(service.Tax),
            Type: "C",
            ColorClass: this.GetColorClass("C")
          },
          {
            Label: "(-) Deduções e abatimentos",
            Value: this.$options.filters.currency(service.ISS),
            Type: "D",
            ColorClass: this.GetColorClass("D")
          },
          {
            Label: "(=) Receita Líquida",
            Value: this.$options.filters.currency(service.ProfitOperation),
            Type: "C",
            ColorClass: this.GetColorClass("C")
          },
          {
            Label: "(-) Custos dos Serviços Prestados - CSP",
            Value: this.$options.filters.currency(service.AcquirerTax),
            Type: "D",
            ColorClass: this.GetColorClass("D")
          },
          {
            Label: "(=) Lucro Bruto",
            Value: this.$options.filters.currency(service.MarginGross),
            Type: "C",
            ColorClass: this.GetColorClass("C")
          },
          {
            Label: "(-) Despesas com Vendas",
            Value: this.$options.filters.currency(service.AmountPartner),
            Type: "D",
            ColorClass: this.GetColorClass("D")
          },
          {
            Label: "(-) Despesas Administrativas",
            Value: this.$options.filters.currency(service.Operation),
            Type: "D",
            ColorClass: this.GetColorClass("D")
          },
          {
            Label: "(-) Despesas Financeiras",
            Value: this.$options.filters.currency(service.CustTransfer),
            Type: "D",
            ColorClass: this.GetColorClass("D")
          },
          {
            Label: service.ProfitOperationNet > 0 ? "(=) Lucro" : "(=) Prejuízo" + " Operacional Líquido",
            Value: this.$options.filters.currency(
              service.ProfitOperationNet > 0 ? service.ProfitOperationNet : service.ProfitOperationNet * -1
            ),
            Type: service.ProfitOperationNet > 0 ? "C" : "D",
            ColorClass: service.ProfitOperationNet > 0 ? this.GetColorClass("C") : this.GetColorClass("D")
          },
          {
            Label: "(-) Provisões IRPJ E CSLL",
            Value: this.$options.filters.currency(service.TaxIR),
            Type: "D",
            ColorClass: this.GetColorClass("D")
          },
          {
            Label: "(=) Resultado Líquido",
            Value: this.$options.filters.currency(service.ProfitNet > 0 ? service.ProfitNet : service.ProfitNet * -1),
            Type: service.ProfitNet > 0 ? "C" : "D",
            ColorClass: service.ProfitNet > 0 ? this.GetColorClass("C") : this.GetColorClass("D")
          }
        ];
      }
    },

    OpenModal: function(modalTitle, service, isDetails) {
      this.modalTitle = modalTitle;
      if (isDetails || this.idMerchant > 0) {
        this.ServiceDetails = [
          {
            Label: "Receita Bruta",
            Value: this.$options.filters.currency(service.Tax),
            Type: "C",
            ColorClass: this.GetColorClass("C")
          },
          {
            Label: "(-) Deduções e abatimentos",
            Value: this.$options.filters.currency(service.ISS),
            Type: "D",
            ColorClass: this.GetColorClass("D")
          },
          {
            Label: "(=) Receita Líquida",
            Value: this.$options.filters.currency(service.ProfitOperation),
            Type: "C",
            ColorClass: this.GetColorClass("C")
          },
          {
            Label: "(-) Custos dos Serviços Prestados - CSP",
            Value: this.$options.filters.currency(service.AcquirerTax),
            Type: "D",
            ColorClass: this.GetColorClass("D")
          },
          {
            Label: "(=) Lucro Bruto",
            Value: this.$options.filters.currency(service.MarginGross),
            Type: "C",
            ColorClass: this.GetColorClass("C")
          }
        ];
      } else {
        this.ServiceDetails = [
          {
            Label: "Receita Bruta",
            Value: this.$options.filters.currency(service.Tax),
            Type: "C",
            ColorClass: this.GetColorClass("C")
          },
          {
            Label: "(-) Deduções e abatimentos",
            Value: this.$options.filters.currency(service.ISS),
            Type: "D",
            ColorClass: this.GetColorClass("D")
          },
          {
            Label: "(=) Receita Líquida",
            Value: this.$options.filters.currency(service.ProfitOperation),
            Type: "C",
            ColorClass: this.GetColorClass("C")
          },
          {
            Label: "(-) Custos dos Serviços Prestados - CSP",
            Value: this.$options.filters.currency(service.AcquirerTax),
            Type: "D",
            ColorClass: this.GetColorClass("D")
          },
          {
            Label: "(=) Lucro Bruto",
            Value: this.$options.filters.currency(service.MarginGross),
            Type: "C",
            ColorClass: this.GetColorClass("C")
          }
        ];
      }
      this.$bvModal.show("mFormService");
    },
    GetProfitChart: function() {
      this.loadingChart = true;
      this.$store
        .dispatch("GetProfitDashboard", {
          idMerchant: this.idMerchant,
          paymentDate: this.paymentDate
        })
        .then(response => {
          this.infoDashboard = response;

          let date = new Date();
          let label = "Valor";
          let borderColor = "rgba(26, 45, 91, 0.8)";
          let backgroundColor = "rgba(0, 101, 179, 0.3)";

          this.chartProfitMonth = {
            labels: [],
            datasets: []
          };
          if (this.infoDashboard.MerchantsProfit != null && this.infoDashboard.MerchantsProfit != undefined) {
            let dataset = {
              label: label,
              borderColor: borderColor,
              backgroundColor: backgroundColor,
              data: []
            };
            this.infoDashboard.MerchantsProfit.forEach(element => {
              this.chartProfitMonth.labels.push(
                new Date(date.getUTCFullYear(), element.ProfitMonth - 1, 1).getShortMonthName()
              );
              dataset.data.push({
                x: element.ProfitMonth - 1,
                y: element.Tax
              });
            });
            this.chartProfitMonth.datasets.push(dataset);
          }
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao carregar o gráfico de faturamento por mês", error);
        })
        .finally(() => (this.loadingChart = false));
    },
    GetReport: function(ev) {
      ev.preventDefault();
      this.loadingReport = true;
      this.$store
        .dispatch("ReportProfit", {
          idMerchant: this.idMerchant,
          paymentDate: this.paymentDate
        })
        .then(response => {
          if (response.UrlReport != null && response.UrlReport != undefined && response.UrlReport != "") {
            this.$makeToast("Aguarde a conclusão do download", "info", "Relatório gerado com sucesso");
            window.open(response.UrlReport, "_self");
          }
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao gerar o relatório", error);
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingReport = false;
          }, 1200);
        });
    }
  }
};
</script>

<style scoped>
.ftr_chart {
  margin-right: 15px;
}
.img-service {
  height: 50px;
  margin-left: 15px;
}
.page-description {
  font-size: 16px;
}
.button-arrow {
  padding: 0px;
}
.text-green {
  color: #0ac37f;
}
.text-red {
  color: #ff0035;
}
.dropdown-toggle-ellipsis-2 {
  font-size: 14pt;
  margin-left: 5px;
  margin-top: -55px;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/profit.vue